export default __webpack_public_path__ + "static/media/FDL_Purple.24541ba2.png";